/**
 * Collapsed-rail child panel, right of the rail. Same geometry as the
 * workspace/account menus: shadow-lg, 8px radius, 4px padding, 6px offset.
 * Click-driven from SidebarNavParent — never hover.
 * Spec: assets/handoffs/design_handoff_app_shell (component table, Collapsed
 * — flyout frame).
 *
 * @param {string} parentLabel - names the parent in the panel header
 * @param {Array<{key,label,to}>} children
 * @param {string=} activeKey
 * @param {function} onNavigate - (key) => void, called after a child link fires
 */
import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import styles from "./NavFlyout.module.scss";

const NavFlyout = ({ parentLabel, children = [], activeKey, onNavigate }) => (
  <div className={styles.panel} role="menu">
    <div className={styles.header}>{parentLabel}</div>
    {children.map((child) => (
      <Link
        key={child.key}
        to={child.to}
        role="menuitem"
        className={classNames(styles.item, {
          [styles["item--current"]]: child.key === activeKey,
        })}
        onClick={() => onNavigate?.(child.key)}
      >
        {child.label}
      </Link>
    ))}
  </div>
);

export default NavFlyout;
